import { ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";
import Reveal from "@/components/Reveal";

export default function CtaFooter() {
  const scrollToConsole = (e) => {
    e.preventDefault();
    document.getElementById("search-console")?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <footer className="border-t border-hairline" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
        <Reveal>
          <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <h2 className="font-display text-5xl leading-[1.05] tracking-tight text-ink md:text-7xl">
                Run your first
                <br />
                <em className="text-crimson">search.</em>
              </h2>
              <p className="mt-6 max-w-md text-sm leading-relaxed text-smoke">
                Type a name, press search, and the official court docket is one
                paste away. No account, no setup.
              </p>
            </div>
            <button
              onClick={scrollToConsole}
              data-testid="cta-button"
              className="group inline-flex items-center justify-center gap-2.5 self-start rounded-md bg-ink px-8 py-4 text-sm font-bold tracking-wide text-ivory transition-colors duration-300 hover:bg-crimson lg:self-auto"
            >
              Open the search console
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>

        <div className="mt-24 flex flex-col gap-8 border-t border-hairline pt-10 md:flex-row md:items-start md:justify-between">
          <Logo />
          <div className="max-w-lg">
            <p className="text-xs leading-relaxed text-smoke" data-testid="footer-disclaimer">
              DocketScout is an independent utility and is not affiliated with,
              endorsed by, or operated by the New York State Unified Court
              System or NYSCEF. All case data is provided by the courts' own
              public search, and results open on the official court website.
            </p>
            <p className="mt-4 text-xs text-smoke/70">
              © {new Date().getFullYear()} DocketScout. Brand name is a
              placeholder — swap it anytime.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
